import { render } from "./Composition.vue?vue&type=template&id=d70ba2ba&scoped=true"
import script from "./Composition.vue?vue&type=script&lang=js"
export * from "./Composition.vue?vue&type=script&lang=js"

import "./Composition.vue?vue&type=style&index=0&id=d70ba2ba&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70ba2ba"]])

export default __exports__